export enum TableViewState {
  Summary,
  Details,
  Partial
}
